import React from 'react'
import { Stack, TableCell, TableRow } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { formatMoney, formatNumber } from '../../../packages/utils/numberFormatters'
import { IssueEntity, TradeData } from '../../../types/IssueEntity'
import DateRange from '../../../components/DateRange'
import { TradesStat } from '../../../types/Instrument'

type TradingStatsRowProps = Pick<IssueEntity, 'currency'> & {
    row: TradeData | TradesStat
    timeLabel: string | null
    sharesInUnit?: number | null
}

function TradingStatsRow({ row, timeLabel, sharesInUnit }: TradingStatsRowProps) {
    const { i18n } = useTranslation()
    const locale = i18n.language
    if (!row || !timeLabel) {
        throw new Error('TradingStatsRow: Missing required props')
    }

    const vwap = row.vwap
    const perShareAdjustedVwap = vwap !== null && typeof sharesInUnit === 'number' ? vwap / sharesInUnit : null
    const perShareAdjustedTotalVwap =
        row.totalQuantity !== null && typeof sharesInUnit === 'number' ? row.totalQuantity * sharesInUnit : null

    if (vwap === null && perShareAdjustedTotalVwap === null && perShareAdjustedVwap === null) return null

    return (
        <>
            <TableRow>
                <TableCell>
                    {timeLabel} <br />
                    <DateRange endDate={row.endDate ?? ''} startDate={row.startDate ?? ''} />
                </TableCell>
                <TableCell>
                    <Stack direction='column'>
                        <div>{formatMoney(vwap, { locale, minDecimals: 0, maxDecimals: 3 }) || '-'}</div>
                        {perShareAdjustedVwap !== null ? (
                            <div>
                                ({formatMoney(perShareAdjustedVwap, { locale, minDecimals: 0, maxDecimals: 3 })})*
                            </div>
                        ) : null}
                    </Stack>
                </TableCell>
                <TableCell>{formatMoney(row.avgTurnover, { locale, decimals: 0 }) || '-'}</TableCell>
                <TableCell>
                    <Stack direction='column'>
                        <div>
                            {formatNumber(row.totalQuantity, {
                                locale,
                                decimals: 0,
                            }) || '-'}
                        </div>
                        {perShareAdjustedTotalVwap ? (
                            <div>
                                (
                                {formatNumber(perShareAdjustedTotalVwap, {
                                    locale,
                                    decimals: 0,
                                })}
                                )*
                            </div>
                        ) : null}
                    </Stack>
                </TableCell>
            </TableRow>
        </>
    )
}

export default TradingStatsRow
